import { graphql, useStaticQuery } from 'gatsby'

const query = graphql`
  query SocialMediaLinks {
    site {
      siteMetadata {
        externalUrls {
          bilibili
          bluesky
          discord
          facebook
          instagram
          linkedin
          reddit
          steam
          substack
          tiktok
          x
          youtube
        }
      }
    }
  }
`

export default () =>
  useStaticQuery<RecursiveNonNullable<Fika.Queries.SocialMediaLinksQuery>>(
    query
  )
